'use strict';

var React = require('react');

function _interopNamespace(e) {
	if (e && e.__esModule) return e;
	var n = Object.create(null);
	if (e) {
		Object.keys(e).forEach(function (k) {
			if (k !== 'default') {
				var d = Object.getOwnPropertyDescriptor(e, k);
				Object.defineProperty(n, k, d.get ? d : {
					enumerable: true,
					get: function () { return e[k]; }
				});
			}
		});
	}
	n["default"] = e;
	return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const SvgRobot = props => /*#__PURE__*/React__namespace.createElement("svg", _extends({
  viewBox: "0 0 29 29",
  height: 24,
  width: 24
}, props), _circle || (_circle = /*#__PURE__*/React__namespace.createElement("circle", {
  cx: 14.5,
  cy: 14.5,
  r: 13.5,
  fill: "currentColor"
})), _path || (_path = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M6.23 12.58h.92v5.51h-.92a.91.91 0 0 1-.92-.91V13.5a.92.92 0 0 1 .92-.92Zm14.7-1.38V19a1.84 1.84 0 0 1-1.84 1.84H9.91A1.84 1.84 0 0 1 8.07 19v-7.8a2.29 2.29 0 0 1 2.29-2.29h3.22V7.07a.92.92 0 0 1 1.84 0v1.84h3.22a2.29 2.29 0 0 1 2.29 2.29Zm-8 2.3a1.15 1.15 0 1 0-1.15 1.15 1.15 1.15 0 0 0 1.15-1.15Zm-.23 3.68h-1.88v.91h1.84Zm2.76 0h-1.88v.91h1.84Zm3-3.68a1.15 1.15 0 1 0-1.15 1.15 1.16 1.16 0 0 0 1.15-1.15Zm-.23 3.68h-1.89v.91h1.84Zm5.51-3.68v3.68a.92.92 0 0 1-.92.91h-.92v-5.51h.92a.92.92 0 0 1 .92.92Z",
  fill: "currentColor"
})));

exports["default"] = SvgRobot;
